export const verificationInformationStrings = {
  strings: {
    en: {
      thankYou: 'Thank you',
      confirmationDesc: 'You have ended your enrollment in the CARE/FERA program.',
      deEnrolled: 'I have disenrolled.',
      deEnrollDesc: 'You have ended your enrollment in the CARE/FERA program.',
      verificationInformation: 'Verification Information',
      customerInformation: 'Account Information',
      tenantInformation: 'Tenant Information',
      landlordInformation: 'Landlord Information',
      customerName: 'Customer Name',
      serviceAccountNumber: 'Service Account Number',
      landlordsServiceAccountNumber: 'Landlord\'s Service Account Number',
      meterAddress: 'Park / Master Meter Address',
      tenantCustomerName: 'Tenant Customer Name',
      tenantNumber: 'Tenant Number',
      unitNumber: 'Unit Number',
      errorHeader: 'We’re sorry, we’ve encountered a problem.',
      errorMsg: 'This service account is not eligible for either the CARE or FERA programs based on the income information provided. If you feel this is incorrect, please try again, or call 1-XXX-XXX-XXXX.',
      enrollmentHeader: 'Sign up for CARE/FERA',
      recertifyHeader: 'Recertify or End Enrollment in CARE/FERA',
      goToSCE: 'Go To SCE.com',
      backToCAREProgramPage: 'Back to CARE program page',
      tryAgain: 'Try Again',
      continueToCAREEnrollment:'Continue to CARE Enrollment'

    },
    zh: {
      thankYou: '謝謝',
      confirmationDesc: '您已經結束了CARE / FERA計劃的註冊。',
      deEnrollDesc: '您已終止加入 CARE/FERA 計劃。',
      deEnrolled: '我已經退出了。',
      verificationInformation: '驗證信息',
      customerInformation: '客戶信息',
      tenantInformation: '租戶信息',
      landlordInformation: '房东信息',
      customerName: '顧客姓名',
      serviceAccountNumber: '服務帳號',
      landlordsServiceAccountNumber: '房東的服務帳號',
      meterAddress: '公园的地址/主地址',
      tenantCustomerName: '租戶客戶名稱',
      tenantNumber: '租戶號碼',
      unitNumber: '單位號碼',
      errorHeader: '很抱歉，我們遇到了問題.',
      errorMsg: '根據提供的收入信息，此服務帳戶不符合CARE或FERA計劃的資格。如果您認為這不正確，請再試一次，或致電1-XXX-XXX-XXXX。',
      recertifyHeader: '重新认证或结束注册 in CARE/FERA',
      enrollmentHeader: '报名参加CARE / FERA',
      goToSCE: '前往 SCE.com',
      backToCAREProgramPage: '返回 CARE/FERA',
      tryAgain: '再試一次',
      continueToCAREEnrollment:'继续关注注册'

    },
    es: {
      verificationInformation: 'Información para la verificación',
      landlordInformation: 'Información del propietario',
      tenantInformation: 'Información del inquilino',
      customerInformation: 'Información de la cuenta',
      errorHeader: 'Lo sentimos, hemos encontrado un problema.',
      thankYou: 'Gracias.',
      confirmationDesc: 'Ha finalizado su inscripción en el programa CARE / FERA.',
      deEnrollDesc: 'Quý vị đã bỏ ghi danh vào chương trình CARE/FERA.',
      deEnrolled: 'Cancelé mi inscripción.',
      customerName: 'Nombre del cliente',
      serviceAccountNumber: 'Cuenta de servicio',
      landlordsServiceAccountNumber: 'Número de cuenta de servicio del propietario',
      meterAddress: 'Parque / Master Meter Dirección',
      tenantCustomerName: 'Nombre del cliente del arrendatario',
      tenantNumber: 'Nombre del inquilino',
      unitNumber: 'Número de unidad',
      recertifyHeader: 'Recertificar o terminar la inscripción in CARE/FERA',
      enrollmentHeader: 'Registrarse en CARE / FERA',
      goToSCE: 'Entra a SCE.com',
      backToCAREProgramPage: 'Volver a la página del programa de CARE',
      tryAgain: 'Inténtalo nuevamente',
      continueToCAREEnrollment:'Continuar con la inscripción de CARE'
    },
    ko: {
      verificationInformation: '확인 정보',
      landlordInformation: '집주인 정보',
      customerInformation: '계정 정보',
      tenantInformation: '임차인 정보',
      errorHeader: '죄송합니다. 문제가 발생했습니다.',
      thankYou: '감사합니다.',
      deEnrollDesc: '고객님께서는 CARE/FERA 프로그램 등록을 마치셨습니다. ',
      confirmationDesc: '고객님의 등록 신청서가 성공적으로 제출되었습니다. ',
      deEnrolled: '본인은 등록을 취소했습니다.',
      customerName: '고객 성명',
      serviceAccountNumber: '서비스 계정 번호',
      landlordsServiceAccountNumber: '임대인의 서비스 계정 번호',
      meterAddress: '공원 / 마스터 미터 주소',
      tenantCustomerName: '임차인 고객 이름',
      tenantNumber: '임차인 번호',
      unitNumber: '유닛 번호',
      recertifyHeader: 'CARE/FERA 재인증 또는 등록 해지',
      enrollmentHeader: 'CARE / FERA에 가입하십시오',
      goToSCE: 'SCE.com으로 가기',
      backToCAREProgramPage: 'CARE/FERA로 돌아가기',
      tryAgain: '다시 시도해 보세요',
      continueToCAREEnrollment:'CARE 등록 계속하기'
    },
    vi: {
      verificationInformation: 'Thông Tin Xác Nhận',
      landlordInformation: 'Thông tin chủ nhà',
      tenantInformation: 'Thông Tin Người Thuê Nhà',
      customerInformation: 'Thông Tin Trương Mục',
      errorHeader: 'Chúng tôi xin lỗi, chúng tôi đã gặp phải một vấn đề.',
      thankYou: 'Cảm ơn!',
      deEnrollDesc: 'Quý vị đã bỏ ghi danh vào chương trình CARE/FERA.',
      confirmationDesc: 'You have ended your enrollment in the CARE/FERA program.',
      deEnrolled: 'Tôi đã bỏ ghi danh.',
      customerName: 'Tên Khách Hàng',
      serviceAccountNumber: 'Số Trương Mục Dịch Vụ',
      landlordsServiceAccountNumber: 'Số Trương Mục Dịch Vụ của Chủ Nhà ',
      meterAddress: 'Địa Chỉ Khu Nhà/Đồng Hồ Chính',
      tenantCustomerName: 'Tên khách hàng thuê nhà',
      tenantNumber: 'Ten Số của Người Thuê Nhà',
      unitNumber: 'Căn Số',
      recertifyHeader: 'Tái Xác Nhận hoặc Bỏ Ghi Danh CARE/FERA',
      enrollmentHeader: 'Đăng ký CHĂM SÓC / FERA',
      goToSCE: 'Vào SCE.com',
      backToCAREProgramPage: 'Trở Lại CARE/FERA',
      tryAgain: 'Thử Lại',
      continueToCAREEnrollment:'Continuar con la inscripción de CARE'
    }
  },

  common: ['print']
};